export const SkillSet = [
    {name : "C Sharp", imagePath : "csharp.png"},
    {name : ".NET Core", imagePath : "net.png"},
    {name : "MySQL", imagePath : "mysql.png"},
    {name : "SQL", imagePath : "sql.png"},
    {name : "HTML", imagePath : "html5.png"},
    {name : "CSS", imagePath : "css3.png"},
    {name : "Javascript", imagePath : "js.png"},
    {name : "Typescript", imagePath : "ts.png"},
    {name : "React", imagePath : "react.png"}
];


export const ToolSet = [
    {name : "Visual Studio", imagePath : "vs.png"},
    {name : "VS Code", imagePath : "vscode.png"},
    {name : "SSMS", imagePath : "ssms.png"},
    {name : "CMD", imagePath : "cmd.png"},
    {name : "Git", imagePath : "git.png"},
    {name : "Firebase", imagePath : "firebase.png"},
    {name : "Docker", imagePath : "docker.png"},
    {name : "AWS", imagePath : "aws.png"},
    {name : "Azure", imagePath : "azure.png"},
];